module.exports = __webpack_public_path__ + "img/wang1.92c2a1d5.png";